export const POLICY = {
  nickname: 'PRODUCTS.POLICY.nickname',
  icon:'policy'
};
